import React, { useCallback, useState } from 'react';
import { getLang, setLang } from './getLang';

const BpIntlProviderContext = React.createContext<{
  currentLang: string;
  defaultLang: string;
  setCurrentLang: (lang: string) => void;
}>({
  currentLang: 'en',
  defaultLang: 'en',
  setCurrentLang: () => {}
});

export const BpIntlProviderContextProvider: React.FC<React.PropsWithChildren<{ supportedLanguages: string[] }>> = ({
  children,
  supportedLanguages
}) => {
  const [currentLang, setCurrentLang] = useState(getLang(supportedLanguages));

  const setContextLang = useCallback(
    (lang: string) => {
      if (supportedLanguages.includes(lang)) {
        setLang(lang);
        setCurrentLang(lang);
      }
    },
    [supportedLanguages]
  );

  return (
    <BpIntlProviderContext.Provider
      value={{
        currentLang,
        defaultLang: supportedLanguages[0] ?? 'en',
        setCurrentLang: setContextLang
      }}
    >
      {children}
    </BpIntlProviderContext.Provider>
  );
};

export const useBpIntlProviderContext = () => React.useContext(BpIntlProviderContext);
